import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, vModelSelect as _vModelSelect, vModelText as _vModelText, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43011568"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "card" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header card-header-stretch" }, [
  /*#__PURE__*/_createElementVNode("ul", {
    class: "nav nav-stretch nav-line-tabs fw-bold border-0",
    role: "tablist",
    id: "purchase_request_tab"
  }, [
    /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
      /*#__PURE__*/_createElementVNode("a", {
        class: "nav-link active",
        "data-bs-toggle": "tab",
        href: `#kt_Details`,
        role: "tab",
        "aria-selected": "true"
      }, "Details")
    ])
  ])
], -1))
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "tab-content" }
const _hoisted_7 = {
  class: "tab-pane fade active show",
  id: `kt_Details`,
  role: "tabpanel"
}
const _hoisted_8 = { class: "px-lg-2 pt-4 ribbon" }
const _hoisted_9 = {
  class: /*#__PURE__*/_normalizeClass(`ribbon-label`)
}
const _hoisted_10 = {
  key: 0,
  class: "py-5 px-lg-2 d-flex align-items-center"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "DesignStock Id", -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_13 = { class: "ps-2 text-primary me-4" }
const _hoisted_14 = { class: "ms-auto" }
const _hoisted_15 = { class: "modal-body py-5 px-lg-2" }
const _hoisted_16 = { class: "scroll-y me-n7 pe-7" }
const _hoisted_17 = { class: "row g-9 mb-7" }
const _hoisted_18 = {
  key: 0,
  class: "col-md-6 fv-row"
}
const _hoisted_19 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_20 = {
  key: 0,
  class: "el-form-item__content"
}
const _hoisted_21 = { class: "el-input el-input--default" }
const _hoisted_22 = ["onUpdate:modelValue", "type"]
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  key: 1,
  class: "col-md-6 fv-row"
}
const _hoisted_25 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  key: 2,
  class: "col-md-6 fv-row"
}
const _hoisted_28 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_29 = ["onUpdate:modelValue"]
const _hoisted_30 = ["value"]
const _hoisted_31 = { key: 1 }
const _hoisted_32 = {
  key: 3,
  class: "col-md-6 fv-row"
}
const _hoisted_33 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_34 = {
  key: 4,
  class: "col-md-6 fv-row"
}
const _hoisted_35 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_36 = {
  key: 5,
  class: "col-md-6 fv-row"
}
const _hoisted_37 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_38 = ["name", "onUpdate:modelValue"]
const _hoisted_39 = { class: "el-form-item__content" }
const _hoisted_40 = ["type", "onUpdate:modelValue", "onChange"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { key: 3 }
const _hoisted_44 = {
  key: 6,
  class: "col-md-6 fv-row"
}
const _hoisted_45 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = {
  key: 7,
  class: "col-md-6 fv-row"
}
const _hoisted_48 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_49 = ["onUpdate:modelValue"]
const _hoisted_50 = { key: 1 }
const _hoisted_51 = {
  key: 8,
  class: "col-md-6 fv-row"
}
const _hoisted_52 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = {
  key: 9,
  class: "col-md-12 fv-row"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator mb-5" }, null, -1))
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = {
  key: 10,
  class: "col-md-12"
}
const _hoisted_58 = {
  key: 11,
  class: "col-md-12 fv-row"
}
const _hoisted_59 = {
  key: 0,
  class: ""
}
const _hoisted_60 = { class: "mb-3 fs-2hx" }
const _hoisted_61 = { class: "fw-bold" }
const _hoisted_62 = { class: "col-md-6 fv-row mb-7" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "Photo")
], -1))
const _hoisted_64 = { key: 1 }
const _hoisted_65 = ["src"]
const _hoisted_66 = {
  key: 2,
  class: "alert alert-danger"
}
const _hoisted_67 = {
  key: 0,
  class: "col-md-12 fv-row mb-7"
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Materials", -1))
const _hoisted_69 = { class: "table-responsive" }
const _hoisted_70 = { class: "table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer" }
const _hoisted_71 = { class: "text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Code", -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Size", -1))
const _hoisted_74 = { key: 0 }
const _hoisted_75 = { key: 1 }
const _hoisted_76 = { key: 2 }
const _hoisted_77 = { key: 3 }
const _hoisted_78 = { key: 0 }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "sec", -1))
const _hoisted_80 = { key: 1 }
const _hoisted_81 = { key: 2 }
const _hoisted_82 = { key: 3 }
const _hoisted_83 = { key: 0 }
const _hoisted_84 = { class: "border-bottom-3" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { colspan: "4" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Material Total")
], -1))
const _hoisted_86 = { class: "text-primary fw-bold" }
const _hoisted_87 = { class: "text-primary fw-bold" }
const _hoisted_88 = { class: "border-top" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { colspan: "5" }, "Peeling Cost", -1))
const _hoisted_90 = { class: "" }
const _hoisted_91 = { class: "border-top" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { colspan: "5" }, "Fusing Cost", -1))
const _hoisted_93 = { class: "" }
const _hoisted_94 = { class: "border-top" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { colspan: "5" }, "Transport Cost", -1))
const _hoisted_96 = { class: "" }
const _hoisted_97 = { class: "border-top border-bottom-3" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { colspan: "5" }, "Other Expenses Cost", -1))
const _hoisted_99 = { class: "" }
const _hoisted_100 = { class: "border-bottom-3" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { colspan: "5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Gross Total Cost")
], -1))
const _hoisted_102 = { class: "text-primary fw-bold" }
const _hoisted_103 = { class: "border-bottom-3" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { colspan: "5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Final Cost")
], -1))
const _hoisted_105 = { class: "text-primary fw-boldest" }
const _hoisted_106 = {
  key: 1,
  class: "modal-footer"
}
const _hoisted_107 = { class: "w-100 d-flex flex-center" }
const _hoisted_108 = ["data-kt-indicator"]
const _hoisted_109 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_110 = /*#__PURE__*/_createTextVNode(" Submit ")
const _hoisted_111 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_112 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_113 = /*#__PURE__*/_createTextVNode(" Please wait... ")
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_115 = [
  _hoisted_113,
  _hoisted_114
]
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_SeasonMultiselect = _resolveComponent("SeasonMultiselect")!
  const _component_PartyMultiselect = _resolveComponent("PartyMultiselect")!
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        class: "back-button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickBack && _ctx.onClickBack(...args)))
      }, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_ctx.selectedTab == 'Details')
              ? (_openBlock(), _createBlock(_component_el_form, {
                  key: 0,
                  class: "card card-bordered",
                  onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
                  model: _ctx.formData,
                  rules: _ctx.rules,
                  ref: "formRef"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.formData.code), 1)
                    ]),
                    (!_ctx.isAdd)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _hoisted_11,
                          _hoisted_12,
                          _createElementVNode("strong", _hoisted_13, _toDisplayString(_ctx.formData.id), 1),
                          _createElementVNode("div", _hoisted_14, [
                            (!_ctx.isEdit)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "btn btn-primary ms-2",
                                  type: "button",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setEdit(true)))
                                }, " Edit "))
                              : _createCommentVNode("", true),
                            (_ctx.isEdit)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  class: "btn btn-primary ms-2",
                                  type: "button",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setEdit(false)))
                                }, " Cancel "))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fieldList, (formItem) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: formItem.name
                            }, [
                              (['color'].indexOf(formItem.type) != -1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                    _createElementVNode("label", _hoisted_19, _toDisplayString(formItem.label), 1),
                                    _createVNode(_component_el_form_item, {
                                      prop: formItem.name
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.isEdit)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                              _createElementVNode("div", _hoisted_21, [
                                                _withDirectives(_createElementVNode("input", {
                                                  class: "el-input__inner",
                                                  "onUpdate:modelValue": ($event: any) => ((_ctx.formData[formItem.name]) = $event),
                                                  type: formItem.type,
                                                  autocomplete: "off",
                                                  placeholder: ""
                                                }, null, 8, _hoisted_22), [
                                                  [_vModelDynamic, _ctx.formData[formItem.name]]
                                                ])
                                              ])
                                            ]))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.formData[formItem.name]), 1))
                                      ]),
                                      _: 2
                                    }, 1032, ["prop"])
                                  ]))
                                : _createCommentVNode("", true),
                              (['text', 'number'].indexOf(formItem.type) != -1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                    _createElementVNode("label", _hoisted_25, _toDisplayString(formItem.label), 1),
                                    _createVNode(_component_el_form_item, {
                                      prop: formItem.name
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.isEdit)
                                          ? (_openBlock(), _createBlock(_component_el_input, {
                                              key: 0,
                                              modelValue: _ctx.formData[formItem.name],
                                              "onUpdate:modelValue": ($event: any) => ((_ctx.formData[formItem.name]) = $event),
                                              type: formItem.type,
                                              placeholder: ""
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "type"]))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.formData[formItem.name]), 1))
                                      ]),
                                      _: 2
                                    }, 1032, ["prop"])
                                  ]))
                                : _createCommentVNode("", true),
                              (formItem.type == 'select')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                    _createElementVNode("label", _hoisted_28, _toDisplayString(formItem.label), 1),
                                    _createVNode(_component_el_form_item, {
                                      prop: formItem.name
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.isEdit)
                                          ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                              key: 0,
                                              class: "form-select rounded-3",
                                              "onUpdate:modelValue": ($event: any) => ((_ctx.formData[formItem.name]) = $event)
                                            }, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formItem.options, (opt) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                  key: opt.id,
                                                  value: opt.id
                                                }, _toDisplayString(opt.label), 9, _hoisted_30))
                                              }), 128))
                                            ], 8, _hoisted_29)), [
                                              [_vModelSelect, _ctx.formData[formItem.name]]
                                            ])
                                          : (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.formData[formItem.name]), 1))
                                      ]),
                                      _: 2
                                    }, 1032, ["prop"])
                                  ]))
                                : _createCommentVNode("", true),
                              (formItem.type == 'SeasonMultiselect')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                    _createElementVNode("label", _hoisted_33, _toDisplayString(formItem.label), 1),
                                    _createVNode(_component_el_form_item, {
                                      prop: formItem.name
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_SeasonMultiselect, {
                                          isEdit: _ctx.isEdit,
                                          class: "form-select rounded-3",
                                          modelValue: _ctx.formData[formItem.name],
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.formData[formItem.name]) = $event)
                                        }, null, 8, ["isEdit", "modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1032, ["prop"])
                                  ]))
                                : _createCommentVNode("", true),
                              (formItem.type == 'PartyMultiselect')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                    _createElementVNode("label", _hoisted_35, _toDisplayString(formItem.label), 1),
                                    _createVNode(_component_el_form_item, {
                                      prop: formItem.name
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_PartyMultiselect, {
                                          isEdit: _ctx.isEdit,
                                          class: "form-select rounded-3",
                                          modelValue: _ctx.formData[formItem.name],
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.formData[formItem.name]) = $event)
                                        }, null, 8, ["isEdit", "modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1032, ["prop"])
                                  ]))
                                : _createCommentVNode("", true),
                              (formItem.type == 'multi-text')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                    _createElementVNode("label", _hoisted_37, _toDisplayString(formItem.label), 1),
                                    _withDirectives(_createElementVNode("input", {
                                      type: "hidden",
                                      name: formItem.name,
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.formData[formItem.name]) = $event)
                                    }, null, 8, _hoisted_38), [
                                      [_vModelText, _ctx.formData[formItem.name]]
                                    ]),
                                    _createElementVNode("div", _hoisted_39, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.multiForm[
                              formItem.name
                            ], (item, itemIndex) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          class: "el-input el-input--default d-flex align-items-center",
                                          key: itemIndex
                                        }, [
                                          (_ctx.isEdit)
                                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                key: 0,
                                                class: "el-input__inner",
                                                type: formItem.multiType,
                                                autocomplete: "off",
                                                placeholder: "",
                                                "onUpdate:modelValue": ($event: any) => ((_ctx.multiForm[formItem.name][itemIndex]) = $event),
                                                onChange: ($event: any) => (
                                _ctx.formData[formItem.name] =
                                  _ctx.multiForm[formItem.name].join(',')
                              )
                                              }, null, 40, _hoisted_40)), [
                                                [_vModelDynamic, _ctx.multiForm[formItem.name][itemIndex]]
                                              ])
                                            : _createCommentVNode("", true),
                                          (itemIndex != 0 && _ctx.isEdit)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 1,
                                                class: "btn btn-danger",
                                                type: "button",
                                                onClick: ($event: any) => (
                                _ctx.multiForm[formItem.name].splice(itemIndex, 1)
                              )
                                              }, " x ", 8, _hoisted_41))
                                            : _createCommentVNode("", true),
                                          (itemIndex == 0 && _ctx.isEdit)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 2,
                                                class: "btn btn-success",
                                                type: "button",
                                                onClick: ($event: any) => (_ctx.multiForm[formItem.name].push(''))
                                              }, " + ", 8, _hoisted_42))
                                            : _createCommentVNode("", true),
                                          (!_ctx.isEdit)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(item), 1))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (formItem.type == 'date')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                    _createElementVNode("label", _hoisted_45, _toDisplayString(formItem.label), 1),
                                    _createVNode(_component_el_form_item, {
                                      prop: formItem.name
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.formData[formItem.name] && _ctx.isEdit)
                                          ? (_openBlock(), _createBlock(_component_datepicker, {
                                              key: 0,
                                              class: "form-control rounded-3",
                                              modelValue: _ctx.formData[formItem.name],
                                              "onUpdate:modelValue": ($event: any) => ((_ctx.formData[formItem.name]) = $event)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(_ctx.moment(_ctx.formData[formItem.name]).format("LLL")), 1))
                                      ]),
                                      _: 2
                                    }, 1032, ["prop"])
                                  ]))
                                : _createCommentVNode("", true),
                              (formItem.type == 'textarea')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                    _createElementVNode("label", _hoisted_48, _toDisplayString(formItem.label), 1),
                                    (formItem.type == 'textarea')
                                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                                          key: 0,
                                          prop: formItem.name
                                        }, {
                                          default: _withCtx(() => [
                                            (_ctx.isEdit)
                                              ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                                  key: 0,
                                                  "onUpdate:modelValue": ($event: any) => ((_ctx.formData[formItem.name]) = $event),
                                                  class: "form-control rounded-3",
                                                  rows: "4"
                                                }, null, 8, _hoisted_49)), [
                                                  [_vModelText, _ctx.formData[formItem.name]]
                                                ])
                                              : (_openBlock(), _createElementBlock("p", _hoisted_50, _toDisplayString(_ctx.formData[formItem.name]), 1)),
                                            _createElementVNode("div", {
                                              class: _normalizeClass(["word-count", 
                              parseInt(_ctx.textAreaWordCount) > 200
                                ? 'error-text'
                                : ''
                            ])
                                            }, _toDisplayString(_ctx.textAreaWordCount) + " of 200 ", 3)
                                          ]),
                                          _: 2
                                        }, 1032, ["prop"]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (formItem.type == 'button' && _ctx.isEdit)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                    _createElementVNode("label", _hoisted_52, _toDisplayString(formItem.label), 1),
                                    (formItem.type == 'button')
                                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                                          key: 0,
                                          prop: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("button", {
                                              type: "button",
                                              class: "btn btn-info",
                                              onClick: formItem.clickEvent
                                            }, _toDisplayString(formItem.label), 9, _hoisted_53)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (formItem.type == 'separator')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_54, _hoisted_56))
                                : _createCommentVNode("", true),
                              (formItem.type == 'blank')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_57))
                                : _createCommentVNode("", true),
                              (formItem.type == 'title')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                    (formItem.type == 'title')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                          _createElementVNode("div", _hoisted_60, [
                                            _createElementVNode("div", _hoisted_61, _toDisplayString(formItem.label), 1)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128)),
                          _createElementVNode("div", _hoisted_62, [
                            _hoisted_63,
                            _createVNode(_component_el_form_item, { prop: 'photo' }, {
                              default: _withCtx(() => [
                                (_ctx.isEdit)
                                  ? (_openBlock(), _createElementBlock("input", {
                                      key: 0,
                                      class: _normalizeClass(`form-control rounded-3 ${
                            _ctx.fileError ? 'is-invalid  mb-2' : ''
                          }`),
                                      ref: "file",
                                      type: "file",
                                      accept: ".jpg",
                                      onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.checkMaxSize && _ctx.checkMaxSize(...args)))
                                    }, null, 34))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_64, [
                                      _createElementVNode("img", {
                                        src: _ctx.formData['image'],
                                        height: "100"
                                      }, null, 8, _hoisted_65)
                                    ])),
                                (_ctx.fileError)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_66, _toDisplayString(_ctx.fileError), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          (_ctx.hasMaterial)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                _hoisted_68,
                                _createElementVNode("div", _hoisted_69, [
                                  _createElementVNode("table", _hoisted_70, [
                                    _createElementVNode("thead", null, [
                                      _createElementVNode("tr", _hoisted_71, [
                                        _hoisted_72,
                                        _hoisted_73,
                                        (_ctx.hasCost)
                                          ? (_openBlock(), _createElementBlock("th", _hoisted_74, "Cutting"))
                                          : _createCommentVNode("", true),
                                        (_ctx.hasCost)
                                          ? (_openBlock(), _createElementBlock("th", _hoisted_75, "Rate"))
                                          : _createCommentVNode("", true),
                                        (_ctx.hasCost)
                                          ? (_openBlock(), _createElementBlock("th", _hoisted_76, "Cost"))
                                          : _createCommentVNode("", true),
                                        (_ctx.hasCost)
                                          ? (_openBlock(), _createElementBlock("th", _hoisted_77, "Cutting Cost"))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.designMaterialList, (designMaterialItem, designMaterialIndex) => {
                                        return (_openBlock(), _createElementBlock("tr", { key: designMaterialIndex }, [
                                          _createElementVNode("td", null, [
                                            _createVNode(_component_router_link, {
                                              to: {
                                    name: 'apps-edit-material',
                                    params: {
                                      id: designMaterialItem.material_data.id,
                                    },
                                  }
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(designMaterialItem.material_data.code), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["to"])
                                          ]),
                                          _createElementVNode("td", null, _toDisplayString(designMaterialItem.width) + " (W) X " + _toDisplayString(designMaterialItem.height) + " (H) = " + _toDisplayString(designMaterialItem.width *
                                  designMaterialItem.height) + " sq " + _toDisplayString(designMaterialItem.material_data.unit), 1),
                                          (_ctx.hasMaterialCost)
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_78, [
                                                _createTextVNode(" ₹ " + _toDisplayString(designMaterialItem.cuttingCost) + " / " + _toDisplayString(designMaterialItem.cuttingTime) + " ", 1),
                                                _hoisted_79
                                              ]))
                                            : _createCommentVNode("", true),
                                          (_ctx.hasMaterialCost)
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_80, " ₹ " + _toDisplayString(designMaterialItem.material_data.rate), 1))
                                            : _createCommentVNode("", true),
                                          (_ctx.hasMaterialCost)
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_81, [
                                                _createElementVNode("strong", null, " ₹ " + _toDisplayString(designMaterialItem.totalCost), 1)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (_ctx.hasMaterialCost)
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_82, [
                                                _createElementVNode("strong", null, " ₹ " + _toDisplayString(designMaterialItem.totalCuttingCost), 1)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ]),
                                    (_ctx.hasMaterialCost)
                                      ? (_openBlock(), _createElementBlock("tfoot", _hoisted_83, [
                                          _createElementVNode("tr", _hoisted_84, [
                                            _hoisted_85,
                                            _createElementVNode("th", _hoisted_86, " ₹ " + _toDisplayString(_ctx.totalCost), 1),
                                            _createElementVNode("th", _hoisted_87, " ₹ " + _toDisplayString(_ctx.totalCuttingCost), 1)
                                          ]),
                                          _createElementVNode("tr", _hoisted_88, [
                                            _hoisted_89,
                                            _createElementVNode("th", _hoisted_90, " ₹ " + _toDisplayString(_ctx.formData.peelingCost || 0), 1)
                                          ]),
                                          _createElementVNode("tr", _hoisted_91, [
                                            _hoisted_92,
                                            _createElementVNode("th", _hoisted_93, " ₹ " + _toDisplayString(_ctx.formData.fusingCost || 0), 1)
                                          ]),
                                          _createElementVNode("tr", _hoisted_94, [
                                            _hoisted_95,
                                            _createElementVNode("th", _hoisted_96, " ₹ " + _toDisplayString(_ctx.formData.transportCost || 0), 1)
                                          ]),
                                          _createElementVNode("tr", _hoisted_97, [
                                            _hoisted_98,
                                            _createElementVNode("th", _hoisted_99, " ₹ " + _toDisplayString(_ctx.formData.otherExpCost || 0), 1)
                                          ]),
                                          _createElementVNode("tr", _hoisted_100, [
                                            _hoisted_101,
                                            _createElementVNode("th", _hoisted_102, " ₹ " + _toDisplayString(_ctx.grossCost), 1)
                                          ]),
                                          _createElementVNode("tr", _hoisted_103, [
                                            _hoisted_104,
                                            _createElementVNode("th", _hoisted_105, " ₹ " + _toDisplayString(_ctx.formData.finalCost), 1)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    (_ctx.isEdit)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                          _createElementVNode("div", _hoisted_107, [
                            _createElementVNode("button", {
                              "data-kt-indicator": _ctx.loading ? 'on' : null,
                              class: "btn btn-lg btn-primary",
                              type: "submit"
                            }, [
                              (!_ctx.loading)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_109, [
                                    _hoisted_110,
                                    _createElementVNode("span", _hoisted_111, [
                                      _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.loading)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_112, _hoisted_115))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_108)
                          ]),
                          _hoisted_116
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["model", "rules"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}